// src/components/SmartWaitlistForm.js
import React from 'react';
import { useAuth } from '../hooks/useAuth';
import WaitlistForm from './WaitlistForm';
import GuardianWaitlistForm from './GuardianWaitlistForm';

/**
 * Smart waitlist form that automatically selects the appropriate form
 * based on user type (Guardian vs regular user)
 */
function SmartWaitlistForm({ 
  courseId, 
  course,
  onWaitlistSuccess, 
  onSuccess, 
  onCancel,
  customMessage,
  existingBookings = [],
  failedStudents = [] 
}) {
  const { user, groups } = useAuth();
  const isGuardian = groups?.includes('Guardian') || user?.groups?.includes('Guardian');
  
  console.log('SmartWaitlistForm - Debug:', {
    isGuardian,
    groups,
    userGroups: user?.groups,
    failedStudents,
    failedStudentsCount: failedStudents.length,
    customMessage
  });
  
  // Handle both onWaitlistSuccess and onSuccess props for compatibility
  const handleSuccess = () => {
    if (onWaitlistSuccess) onWaitlistSuccess();
    if (onSuccess) onSuccess();
  };

  // If user is a guardian, use the enhanced Guardian form
  if (isGuardian) {
    console.log('SmartWaitlistForm - Routing to GuardianWaitlistForm');
    return (
      <GuardianWaitlistForm
        courseId={courseId || course?.courseId}
        onWaitlistSuccess={handleSuccess}
        existingBookings={existingBookings}
        failedStudents={failedStudents}
        customMessage={customMessage}
      />
    );
  }

  // For regular users, use the standard form
  return (
    <WaitlistForm
      courseId={courseId || course?.courseId}
      course={course}
      onWaitlistSuccess={handleSuccess}
      onSuccess={onSuccess}
      onCancel={onCancel}
      customMessage={customMessage}
    />
  );
}

export default SmartWaitlistForm;